import { axiosClient } from '../../clients/axios-client'
import type { FileInfoType, FileParsingStatus } from '../../types'
import type { FileResponseDto } from './dtos/file'
import { FileResponseDtoSchema } from './dtos/file'

export async function getFile(fileId: string) {
  try {
    const { data } = await axiosClient.get<FileResponseDto>(`/filepool/files/${fileId}`)

    const parsedData: FileResponseDto = FileResponseDtoSchema.parse(data)

    const { file, error_message } = parsedData

    const response: FileInfoType = {
      id: file.file_id,
      name: file.filename,
      type: file.file_type,
      parsingStatus: file.parsing_status as FileParsingStatus,
      uploadedAt: file.uploaded_at,
      expiresAt: file.expires_at,
      isExcluded: file.is_excluded ?? false,
      ...(error_message ? { errorMessage: error_message } : {}),
    }

    return response
  } catch (error) {
    console.error(`Getting a file failed. File id: ${fileId}`, error)
    throw error
  }
}
